import moment from "moment";
import { CAC_USER_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Id",
    field: "_id",
    flex: 1,
    hide: true,
  },
  {
    headerName: "User Name",
    field: "username",
    flex: 1,
  },
  {
    headerName: "Company",
    field: "company",
    flex: 1,
  },
  {
    headerName: "Created Time",
    field: "createdTime",
    flex: 1,
  },
  {
    headerName: "Updated Time",
    field: "updatedTime",
    flex: 1,
  },
];

export const columnDefsFunctions = {
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
};

export const transformPayload = (user) => {
  return {
    _id: user?._id || undefined,
    username: user?.username || "",
    password: user?.password || "",
  };
};

export const initial_state_cac_user = {
  type: CAC_USER_TAB,
  label: "CAC Users",
  allowMultipleTabs: false,
};
